import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import SmartImage from "./SmartImage";
import { useI18n } from "../i18n";

export function availability(project) {
  const freeFlats = Math.max(0, project.kapacitet_stanovi - project.zauzetost_stanovi);
  const freeShops = Math.max(0, project.kapacitet_lokali - project.zauzetost_lokali);
  const soldPct = project.kapacitet_stanovi
    ? Math.round((project.zauzetost_stanovi / project.kapacitet_stanovi) * 100)
    : 0;
  return { freeFlats, freeShops, soldPct };
}

export default function ProjectCard({ project }) {
  const { t, lp, field } = useI18n();
  const { freeFlats, freeShops, soldPct } = availability(project);
  const about = field(project, "informacije_o_zgradi");
  return (
    <article className="project-card" data-testid="project-card">
      <div className="project-card-media">
        <SmartImage src={project.slike[0]} alt={`${project.identifier}, ${project.naziv}`} placeholder={t("project.photosSoon")} />
        <span className="project-card-tag">{project.identifier}</span>
      </div>
      <div className="project-card-body">
        <h3>{project.naziv}</h3>
        <p className="project-card-address">
          <MapPin size={16} aria-hidden="true" /> {project.adresa}
        </p>
        {about && <p className="project-card-text">{about}</p>}

        <div className="availability">
          <div className="availability-row">
            <strong>{t("project.freeFlats", { count: freeFlats })}</strong>
            <span>{t("project.soldPct", { pct: soldPct })}</span>
          </div>
          <div
            className="availability-bar"
            role="progressbar"
            aria-valuenow={soldPct}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={t("project.soldAria", { pct: soldPct })}
          >
            <span style={{ width: `${soldPct}%` }} />
          </div>
        </div>

        <dl className="project-card-facts">
          <div>
            <dt>{t("project.price")}</dt>
            <dd>
              {project.najniza_cena && project.najvisa_cena
                ? `${project.najniza_cena.replace(/\s*\+\s*PDV/i, "")}${t("catalogue.priceTo", { price: project.najvisa_cena })}`
                : project.najniza_cena || t("common.priceOnRequest")}
            </dd>
          </div>
          <div>
            <dt>{t("project.shops")}</dt>
            <dd>{freeShops ? t("project.freeShops", { count: freeShops }) : t("project.soldOut")}</dd>
          </div>
          {project.spratnost && (
            <div>
              <dt>{t("project.floors")}</dt>
              <dd>{/^\d+$/.test(project.spratnost) ? t("project.floorsValue", { count: project.spratnost }) : project.spratnost}</dd>
            </div>
          )}
        </dl>

        <Link to={lp(`/katalog/${project.slug}`)} className="btn btn--block">
          {t("project.seeUnits")} <ArrowRight size={18} />
        </Link>
      </div>
    </article>
  );
}
